export const getPhoneValueOrEmptyString = queryParam => (queryParam ? `+${queryParam.trim()}` : '');

export const formatPhoneNumber = phone => {
  const splitted = phone.match(/.{1,4}/g);
  const head = splitted[0];
  const tail = splitted.slice(1);
  const splittedHead = head.match(/.{1,3}/g);
  return [...splittedHead, ...tail].join(' ');
};
